module.exports = __webpack_public_path__ + "img/ethan_moustache.9b1d93cb.png";